var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('PostSection',{attrs:{"right":_vm.right,"lift":_vm.lift}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }